import React, { Component } from 'react';
import styles from './Styles';
import File from 'components/File';
import { Units } from 'Css';
import { translate as _l } from 'oxygen-i18n';
import { formatDate } from '../../../helpers/formatDate';

addTranslations({
  'en-US': {
    no_feedback: 'No feedback provided',
    no_feedback_text: 'No feedback text provided',
  },
  'sv-SE': {
    no_feedback: 'Ingen återkoppling lämnad',
    no_feedback_text: 'Ingen återkopplingstext lämnad',
  },
});

const css = oxygenCss({
  fileContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  file: {
    flexGrow: 0,
    flexShrink: 0,
    margin: Units.base,
    position: 'relative',
  },
});

export default class TaskFeedback extends Component {
  static displayName = 'TaskFeedback';

  static defaultProps = {
    files: [],
  };

  render() {
    let { files, answers, leftIcon, rightIcon, created, ...other } = this.props;

    if (created) {
      created = formatDate(created);
    }

    if (leftIcon) {
      leftIcon = React.cloneElement(leftIcon, {
        style: styles.answer.leftIcon,
      });
    }
    if (rightIcon) {
      rightIcon = React.cloneElement(rightIcon, {
        style: styles.answer.rightIcon,
      });
    }

    return (
      <div style={styles.answer.root} {...other}>
        <div>
          {answers.map((answer, index) => {
            let [feedback, color, icon] = answer;
            return (
              <div key={index} style={{ color }}>
                <p style={{ color, margin: 0 }}>
                  {feedback.text ||
                    (feedback.grade && <i>{_l`no_feedback_text`}</i>) || (
                      <i>{_l`no_feedback`}</i>
                    )}{' '}
                  {icon ? React.cloneElement(icon) : null}
                </p>
                <p style={{ color, margin: 0 }}>
                  {feedback.hasOwnProperty('grade')
                    ? `Grade: ${feedback.grade > 0 ? 'Correct' : 'Incorrect'}`
                    : null}
                </p>
                <i>{feedback.created && feedback.created}</i>
              </div>
            );
          })}
          {leftIcon}
          {rightIcon}
        </div>
        <div className={css.fileContainer}>
          {files.map((file, index) => (
            <div key={index} className={css.file}>
              <div>
                <File url={file.url} caption={file.name} />
              </div>
            </div>
          ))}
        </div>
        <div>
          {created}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/TaskFeedback.js